
/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

export const LAMPORTS_PER_SOL = 1_000_000_000;
export const MIST_PER_SUI = 1_000_000_000;

export const solToLamports = (sol: number): number => {
    return Math.floor(sol * LAMPORTS_PER_SOL);
};

export const lamportsToSol = (lamports: number): number => {
    return lamports / LAMPORTS_PER_SOL;
};

export const suiToMist = (sui: number): number => {
    return Math.floor(sui * MIST_PER_SUI);
};

export const mistToSui = (mist: number): number => {
    return mist / MIST_PER_SUI;
};

export const shortenString = (str: string, len = 4) => {
    if (!str) return '';
    return `${str.slice(0, len)}...${str.slice(-len)}`;
};
